import { Skeleton, Typography } from 'antd';
import styled from 'styled-components';
import {FC} from "react";

const { Text } = Typography;

const CountWrapper = styled.div`
    font-weight: bold;
    margin: 16px 0 0;
`;

interface CandidateCountDisplayProps {
    count: number | undefined;
    isLoading: boolean;
}

export const CandidateCountDisplay: FC<CandidateCountDisplayProps> = ({ count, isLoading }) => {
    return (
        <CountWrapper>
            Kandidatenpool: {isLoading ? (
            <Skeleton.Button active={true} style={{ width: 128, height: 16, verticalAlign: 'middle' }} size='small' shape='default' />
        ) : (
            <Text>{`(${count ?? 0} Kandidaten)`}</Text>
        )}
        </CountWrapper>
    );
};
